import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectMessage, selectDiscountCode, selectSourceRef } from '@store/order/selectors';
import { setMessage, setDiscountCode, setSourceRef } from '@store/order/slice';
import { TextArea } from '@components/text-field/TextArea';
import TextField from '@components/text-field/TextField';
import Select from '@components/select/Select';
import SelectItem from '@components/select/SelectItem';



const MessageDiscount = () => {
	const { t } = useTranslation('forms');

	const message = useSelector(selectMessage);
	const discountCode = useSelector(selectDiscountCode);
	const sourceRef = useSelector(selectSourceRef);
	
	const dispatch = useDispatch();
	const updateMessage = (value: string | null) => dispatch(setMessage(value));
	const updateDiscountCode = (value: string | null) => dispatch(setDiscountCode(value));
	const updateSourceRef = (value: string | null) => dispatch(setSourceRef(value));

	return (
		<div className='message-discount-section'>

			<div className='source-section'>
				<Select
					label={t('inputLabels.sourceRef')}
					selectedKey={sourceRef}
					placeholder={t('shared.selectPlaceholder')}
					onSelectionChange={(key) => {
						if (key && typeof key === 'string') {
							updateSourceRef(key);
						}
					}}
				>
					<SelectItem id={t('sourceRef.option1')}>{t('sourceRef.option1')}</SelectItem>
					<SelectItem id={t('sourceRef.option2')}>{t('sourceRef.option2')}</SelectItem>
					<SelectItem id={t('sourceRef.option3')}>{t('sourceRef.option3')}</SelectItem>
					<SelectItem id={t('sourceRef.option4')}>{t('sourceRef.option4')}</SelectItem>
					<SelectItem id={t('sourceRef.option5')}>{t('sourceRef.option5')}</SelectItem>
					<SelectItem id={t('sourceRef.option6')}>{t('sourceRef.option6')}</SelectItem>
					<SelectItem id={t('sourceRef.option7')}>{t('sourceRef.option7')}</SelectItem>
				</Select>
			</div>

			<div className='message-section'>
				<TextArea
					label={t('inputLabels.messageLong')}
					rounded={true}
					maxLength={250}
					value={message ? message : undefined}
					onChange={(value: string) => !value && value.length === 0 ? updateMessage(null) : updateMessage(value)} />
			</div>

			<div className='discount-section'>
				<TextField
					label={t('inputLabels.discount')}
					value={discountCode ? discountCode : undefined}
					maxLength={50}
					onChange={(value: string) =>
						!value && value.length === 0 ? updateDiscountCode(null) : updateDiscountCode(value)} />
			</div>

		</div>
	);
};

export default MessageDiscount;